export default __webpack_public_path__ + "static/media/psactions_graphicdesign.21f83a2d.jpg";